// extracted by mini-css-extract-plugin
export default {"tag":"f3e761f1b7a2"};